<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">CityBD List</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" /></div>
                    <div class="col-sm-3">
                        <mat-select placeholder="Circle" (selectionChange)="loadUsersList(0,perpage)"
                            [(ngModel)]="circle" (click)="setSearchValue()">
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option>All</mat-option>
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <mat-select placeholder="Status" (selectionChange)="loadUsersList(0,perpage)"
                            [(ngModel)]="status">
                            <mat-option>All</mat-option>
                            <mat-option value="1">Active</mat-option>
                            <mat-option value="0">In-Active</mat-option>
                            <mat-option value="2">Deleted</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadUsersList(0,perpage)"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    </div>

                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadUsersList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Contact Number</th>
                            <th>Employee Id</th>
                            <th>Role</th>
                            <th>Circle</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of usersList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{user.name}}</td>
                            <td>{{user.mobile}}</td>
                            <td>{{user.employee_id}}</td>
                            <td>
                                <span *ngIf="user.role=='10' && user.is_cm_access==0">City BD</span>
                                <span *ngIf="user.role=='10' && user.is_cm_access==1">City BD Manager</span>
                            </td>
                            <td [innerHTML]="getCircleName(user.circle_name) | safe:'html'"></td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="user.status=='1'">Active</span>
                                <span class="badge bg-azure-light" *ngIf="user.status=='0'">In-Active</span>
                                <span class="badge bg-red" *ngIf="user.status=='2'">Deleted</span>
                            </td>
                            <td>
                                <div class="dropdown">
                                    <a class="btn btn-secondary"
                                        routerLink="/city-bd-tracker/{{user.id}}" type="button" target="_blank">
                                        Tracking History</a>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !usersList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Users not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>